export default __webpack_public_path__ + "static/3-7175b8bacca971d93114a771332fcb8e.jpg";